import React, { useState } from 'react';
import '../common.scss';
import TextField from '../../../controls/textField';
import { creamCost, roundTo } from 'shared';
import { stringToNumberOrFalse } from '../../../../utils/utils';
import Button from '../../../controls/button';
import useUserData from '../../../../contexts/userData';
import useAlert from '../../../../contexts/alert';
import useWeb3 from '../../../../contexts/web3';
import useCream from '../../../../contexts/cream';

interface Amount {
  cream: string;
  error: boolean;
  ethAmount: number;
}

const BuyView = () => {
  const alert = useAlert();
  const { loggedIn, login } = useUserData();
  const { handleMetamaskClick } = useWeb3();
  const { buyCream } = useCream();
  const [amount, setAmount] = useState<Amount>({
    cream: '100',
    error: false,
    ethAmount: 100 * creamCost
  });
  const [buyLoading, setBuyLoading] = useState<boolean>(false);

  const handleChange = (newAmount: string) => {
    if (buyLoading) return;
    const numeric = stringToNumberOrFalse(newAmount);
    if (numeric === false) {
      return setAmount({
        cream: newAmount,
        error: true,
        ethAmount: -1
      });
    }
    setAmount({
      cream: newAmount,
      error: false,
      ethAmount: numeric * creamCost
    });
  };

  const handleBuyClick = () => {
    if (!loggedIn) return login();
    if (amount.error || isNaN(amount.ethAmount) || amount.ethAmount <= 0) {
      return alert.showError('Incorrect cream amount');
    }
    handleMetamaskClick(proceedWithClick, 'buy cream');
  };

  const proceedWithClick = () => {
    setBuyLoading(true);
    const clone = { ...amount };
    buyCream({
      cream: clone.cream,
      eth: clone.ethAmount,
      stopLoading: () => setBuyLoading(false),
      onFinish: () => {
        setAmount({
          cream: '',
          error: true,
          ethAmount: -1
        });
      }
    });
  };

  return (
    <div className='creamshop-view'>
      <h1 className='creamshop-view-title'>Buy $CREAM</h1>
      <div className='creamshop-view-textfield-wrapper'>
        <TextField
          value={amount.cream}
          setValue={(newAmount) => handleChange(newAmount)}
          type='price'
          className='creamshop-view-textfield'
          autoFocus
          placeholder='How much?'
          disabled={buyLoading}
          symbolsLimit={6}
          valid={!amount.error || amount.cream === ''}
        />
        {!amount.error && (
          <span className='body-2'>
            $CREAM = {roundTo(amount.ethAmount, 5)}{' '}
            {process.env.REACT_APP_CURRENCY_SYMBOL}
          </span>
        )}
      </div>
      <Button
        className='creamshop-view-button'
        color='primary'
        disabled={amount.error}
        loading={buyLoading}
        onClick={handleBuyClick}
      >
        Buy
      </Button>
    </div>
  );
};

export default BuyView;
